/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { InAppEditorName } from 'cio/utils/editor-utils';
import { action } from '@ember/object';
import { DEFAULT_IN_APP_TEMPLATE_BODY } from 'cio/utils/in-app/preview';

interface StartFromScratchCardSignature {
  Args: {
    isSelecting: boolean;
    onCreate: (editor: InAppEditorName) => void;
  };
  Element: HTMLDivElement;
}

export default class StartFromScratchCard extends Component<StartFromScratchCardSignature> {
  readonly snippet = DEFAULT_IN_APP_TEMPLATE_BODY;

  @action
  onCreate() {
    this.args.onCreate(InAppEditorName.VISUAL);
  }
}
